import React, {useState, useEffect, Fragment} from 'react';
import { NavLink } from 'react-router-dom';
import config from './config';


const Sidebar = (props) => {
    return (
        
        <div className="accordion">
            <div className="accordion__item">
                {/* Checked fund group name and added condition "active" class. */}
                <div className={"accordion__item__header " +(props.StateSession.group === 'Fixed Income' ? 'active' : '')}>

                    {/* Checked fund group name and added condition "active-dis" class. */}
                    <NavLink to="/markets/Epic-FixedIncome" className={"navlink a " +(props.StateSession.group === 'Fixed Income' ? 'active-dis' : '')}>Fixed Income</NavLink>
                </div>

                {/* Checked fund group name and added condition "block" class. */}
                <div className={"accordion__item__content " + (props.StateSession.group === 'Fixed Income' ? 'block' : '')}>
                    <ul>

                        {/* Checked fund url and added condition "a-active-color" class. */}
                        <li><NavLink to="/markets/EpicNextGenUcitsFundRoute" className={"navlink a " + (props.StateSession.url == 'EpicNextGenUcitsFundRoute' ? ' a-active-color' : '')}>EPIC - Next Generation Bond Fund (UCITS)<span className="fa fa-angle-right"></span></NavLink></li>
                        <li><NavLink to="/markets/SegregatedMandates" className={"navlink a " + (props.StateSession.url == 'SegregatedMandates' ? ' a-active-color' : '')}>Segregated Mandates<span className="fa fa-angle-right"></span></NavLink></li>

                    </ul>
                </div>
            </div>
            <div className="accordion__item">
                {/* Checked fund group name and added condition "active" class. */}

                <div className={"accordion__item__header " +(props.StateSession.group === 'Managed Futures' ? 'active' : '')}>

                    {/* Checked fund group name and added condition "active-dis" class. */}
                    <NavLink to="/markets/Epic-ManagedFutures" className={"navlink a " +(props.StateSession.group === 'Managed Futures' ? 'active-dis' : '')}>Managed Futures </NavLink>
                </div>

                {/* Checked fund group name and added condition "block" class. */}
                <div className={"accordion__item__content " + (props.StateSession.group === 'Managed Futures' ? 'block' : '')}>
                    <ul>
                        {/* Checked fund url and added condition "a-active-color" class. */}
                        <li><NavLink to="/markets/EpicfinanceTrends" className={"navlink a " + (props.StateSession.url == 'EpicfinanceTrends' ? ' a-active-color' : '')}>EPIC Financial Trends <span className="fa fa-angle-right"></span></NavLink></li>
                    </ul>
                </div>
            </div>
            <div className="accordion__item">

                {/* Checked fund group name and added condition "active" class. */}
                <div className={"accordion__item__header " +(props.StateSession.group === 'Equities' ? 'active' : '')}>

                    {/* Checked fund group name and added condition "active-dis" class. */}
                    <NavLink to="/markets/Epic-Equitites" className={"navlink a " +(props.StateSession.group === 'Equities' ? 'active-dis' : '')}>Equities</NavLink>
                </div>

                {/* Checked fund group name and added condition "block" class. */}
                <div className={"accordion__item__content " + (props.StateSession.group === 'Equities' ? 'block' : '')}>
                    <ul>
                        <li>
                             {/* Checked fund url and added condition "a-active-color" class. */}
                            <NavLink to="/markets/EpicglobalEquity" className={"navlink a " + (props.StateSession.url == 'EpicglobalEquity' ? ' a-active-color' : '')}>EPIC Global Equity Fund <span className="fa fa-angle-right"></span></NavLink>
                        </li>
                        <li>
                             {/* Checked fund url and added condition "a-active-color" class. */}
                            <NavLink to="/markets/EpicorientalFocus" className={"navlink a " + (props.StateSession.url == 'EpicorientalFocus' ? ' a-active-color' : '')}>EPIC Oriental Focus Fund <span className="fa fa-angle-right"></span></NavLink>
                        </li>
                        <li>
                             {/* Checked fund url and added condition "a-active-color" class. */}
                            <NavLink to="/markets/EpicAsianCentricGlobalGrowth" className={"navlink a "  +(props.StateSession.url === 'EpicAsianCentricGlobalGrowth' ? ' a-active-color' : '')}>VT EPIC Asian Centric Global Growth Fund <span className="fa fa-angle-right"></span></NavLink>
                        </li>
                        <li>
                             {/* Checked fund url and added condition "a-active-color" class. */}
                            <NavLink to="/markets/AIMPortfolioDFM" className={"navlink a "   +(props.StateSession.url == 'AIMPortfolioDFM' ? ' a-active-color' : '')}>AIM Portfolio <span className="fa fa-angle-right"></span></NavLink>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="accordion__item">

                {/* Checked fund group name and added condition "active" class. */}
                <div className={"accordion__item__header "  +(props.StateSession.group === 'Multi Asset' ? 'active' : '')}>

                    {/* Checked fund group name and added condition "active-dis" class. */}
                    <NavLink to="/markets/Epic-MultiAsset" className={"navlink a " +(props.StateSession.group === 'Multi Asset' ? 'active-dis' : '')}>Multi Asset</NavLink>
                </div>

                {/* Checked fund group name and added condition "block" class. */}
                <div className={"accordion__item__content " + (props.StateSession.group === 'Multi Asset' ? 'block' : '')}>
                    <ul>
                        <li>
                             {/* Checked fund url and added condition "a-active-color" class. */}
                            <NavLink to="/markets/EpicipWealthFund" className={"navlink a "  + (props.StateSession.url == 'EpicipWealthFund' ? ' a-active-color' : '')}>EPIC Wealth Fund <span className="fa fa-angle-right"></span></NavLink>
                            </li>
                        {/* code required In future  */}
                        {/* <li><NavLink to="/markets/EpicipMultiAssetFund" className="navlink a">VT EPIC Multi Asset Balanced <span className="fa fa-angle-right"></span></NavLink></li> */}
                        <li>
                             {/* Checked fund url and added condition "a-active-color" class. */}
                            <NavLink to="/markets/EpicipMultiAssetGrowthFund" className={"navlink a " + (props.StateSession.url == 'EpicipMultiAssetGrowthFund' ? ' a-active-color' : '')}>VT EPIC Multi Asset Growth <span className="fa fa-angle-right"></span></NavLink>
                        </li>
                        <li>
                            {/* Checked fund url and added condition "a-active-color" class. */}
                            <NavLink to="/markets/RiskEpicDFM" className={"navlink a " + (props.StateSession.url == 'RiskEpicDFM' ? ' a-active-color' : '')}>EPIC MPS Risk Managed Decumulation 5 <span className="fa fa-angle-right"></span></NavLink>
                        </li>
                        <li>
                            {/* Checked fund url and added condition "a-active-color" class. */}
                            <NavLink to="/markets/RTM3" className={"navlink a " + (props.StateSession.url === 'RTM3' ? ' a-active-color' : '')}>EPIC MPS Risk Target Managed 3 <span className="fa fa-angle-right"></span></NavLink>
                        </li>
                        <li>
                            {/* Checked fund url and added condition "a-active-color" class. */}
                            <NavLink to="/markets/RTM5" className={"navlink a " + (props.StateSession.url === 'RTM5' ? ' a-active-color' : '')}>EPIC MPS Risk Target Managed 5 <span className="fa fa-angle-right"></span></NavLink>
                        </li>
                        <li>
                            {/* Checked fund url and added condition "a-active-color" class. */}
                            <NavLink to="/markets/RTM7" className={"navlink a " + (props.StateSession.url === 'RTM7' ? ' a-active-color' : '')}>EPIC MPS Risk Target Managed 7 <span className="fa fa-angle-right"></span></NavLink>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="accordion__item">

                {/* Checked fund group name and added condition "active" class. */}
                <div className={"accordion__item__header "  +(props.StateSession.group === 'Fund of Hedge Funds' ? 'active' : '')}>

                    {/* Checked fund group name and added condition "active-dis" class. */}
                    <NavLink to="/markets/Hedge-Funds" className={"navlink a " +(props.StateSession.group === 'Fund of Hedge Funds' ? 'active-dis' : '')}>Fund of Hedge Funds </NavLink>
                </div>
            </div>


        </div>
        );
    };
    export default Sidebar; 